import { Injectable } from '@angular/core';
import type { ChatBot, ChatBotEntity, MessengerChatBot, TelegramChatBot } from '@common/types/chat-bot.type';

const ACTIVE_BOT_STATUS: number = 3;

@Injectable({
    providedIn: 'root',
})
export class ChatBotsService {
    public normalizeChatBots(messenger: string, chatBots: ChatBot[]): ChatBotEntity[] {
        const activeChatBots = chatBots.filter((chatBot) => chatBot.status === ACTIVE_BOT_STATUS);

        if (messenger === 'telegram') {
            return (activeChatBots as TelegramChatBot[]).map((chatBot) => ({
                name: chatBot.telegram.username,
                externalId: chatBot._id,
                id: chatBot.telegram.id,
                variables: chatBot.contact_variables,
            }));
        }

        if (messenger === 'messenger') {
            return (activeChatBots as MessengerChatBot[]).map((chatBot) => ({
                name: chatBot.messenger.name,
                externalId: chatBot.id,
                id: chatBot.messenger.id,
                variables: chatBot.contact_variables,
            }));
        }

        if (messenger === 'instagram') {
            return (activeChatBots as any[]).map((chatBot) => ({
                name: chatBot.name,
                externalId: chatBot._id,
                id: chatBot.channel_data.ig_user.username,
                variables: chatBot.contact_variables,
            }));
        }

        if (messenger === 'viber') {
            return (activeChatBots as any[]).map((chatBot) => ({
                name: chatBot.name,
                externalId: chatBot._id,
                id: chatBot.channel_data.vb_account_info.id,
                variables: chatBot.contact_variables,
                uri: chatBot.channel_data.vb_account_info.uri,
            }));
        }

        if (messenger === 'whatsapp') {
            return (activeChatBots as any[]).map((chatBot) => ({
                name: chatBot.name,
                externalId: chatBot._id,
                id: chatBot.channel_data.waba_phone.id,
                phone: chatBot.channel_data.phone.toString(),
                variables: chatBot.contact_variables,
            }));
        }

        if (messenger === 'tiktok') {
            return (activeChatBots as any[]).map((chatBot) => ({
                name: chatBot.channel_data.account.username,
                externalId: chatBot._id,
                id: chatBot.channel_data.business_id,
                variables: chatBot.contact_variables,
            }));
        }

        return activeChatBots as any[];
    }
}
